import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(private swUpdate: SwUpdate) {
    if (swUpdate.isEnabled) {
      // Check for updates every 30 seconds
      setInterval(() => {
        swUpdate.checkForUpdate();
      }, 30000);

      // Listen for version updates
      swUpdate.versionUpdates
        .pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
          map(evt => ({
            type: 'UPDATE_AVAILABLE',
            current: evt.currentVersion,
            available: evt.latestVersion,
          })),
        )
        .subscribe(evt => {
          console.log('App update available:', evt);
          this.promptUser();
        });

      // Listen for unrecoverable state
      swUpdate.unrecoverable.subscribe(event => {
        console.error('Service worker in unrecoverable state:', event);
        this.notifyUser(
          'An error occurred that we cannot recover from. Please reload the page.'
        );
      });
    }
  }

  private promptUser(): void {
    const updateMessage = 'A new version of the app is available. Would you like to update now?';
    
    if (confirm(updateMessage)) {
      this.activateUpdate();
    }
  }

  private activateUpdate(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.activateUpdate().then(() => {
        console.log('App updated successfully');
        document.location.reload();
      }).catch(err => {
        console.error('Failed to activate update:', err);
      });
    }
  }

  private notifyUser(message: string): void {
    console.log('UpdateService notification:', message);
    // You can replace this with a proper notification service
    // For example, Angular Material Snackbar
    alert(message);
  }

  // Manual update check
  checkForUpdate(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().then(() => {
        console.log('Manual update check completed');
      }).catch(err => {
        console.error('Manual update check failed:', err);
      });
    }
  }

  // Force update activation
  forceUpdate(): void {
    this.activateUpdate();
  }

  // Get current version info
  getCurrentVersion(): Promise<any> {
    if (this.swUpdate.isEnabled) {
      return this.swUpdate.checkForUpdate().then(() => {
        return 'Version check completed';
      });
    }
    return Promise.resolve('Service worker not enabled');
  }
} 